/**
 * Created by ivan on 07.03.18.
 */

ExplosionView.prototype._animate = ExplosionView.prototype.animate;
ExplosionView.prototype.animate = function (color, duration) {
    this._animate(cleverapps.styles.COLORS.CELL_COLORS[ColorComponent.COLOR_W], duration);
};
